// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "1a27f3f4" + "." + "680411ad2548f99902c4" + ".js";
};